import { useState, useMemo, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useHistory } from "../../../helpers/useNavigate";
import { useGetAllOffices } from "../../../services/officeService";
import { OfficeItem } from "../OfficeItem/OfficeItem";
import { OfficeCrudModals } from "../OfficeCrudModals/OfficeCrudModals";
// import { AddEntityButton } from "../../../components/AddEntityButton/AddEntityButton";
// import { strings } from "../../../config/string";
import { OfficeForeignIdMapModal } from "../../../components/modals/OfficeForeignIdMapModal";
import debounce from 'lodash/debounce';
import orderBy from 'lodash/orderBy';
import { Office } from "../../../types";

export const OfficesContainer = () => {
  const { data: allOffices = [] } = useGetAllOffices();
  const [selectedOfficeId, setSelectedOfficeId] = useState<string>();
  const [showEdit, setShowEdit] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showForeignIdModal, setShowForeignIdModal] = useState(false);
  const history = useHistory();

  const [filterInput, setFilterInput] = useState('');
  const [debouncedFilterInput, setDebouncedFilterInput] = useState('');

  useEffect(() => {
      const handler = debounce(() => {
          setDebouncedFilterInput(filterInput);
      }, 300);

      handler();

      return () => {
          handler.cancel();
      };
  }, [filterInput]);

  const filteredOffices = useMemo(() => {
    let officesToFilter = allOffices;
    if (debouncedFilterInput) {
      const lowerCaseFilter = debouncedFilterInput.toLowerCase();
      officesToFilter = allOffices.filter((office: Office) =>
        office.name.toLowerCase().includes(lowerCaseFilter) ||
        office.description.toLowerCase().includes(lowerCaseFilter) ||
        (office.foreignId && office.foreignId.toString().includes(lowerCaseFilter))
      );
    }
    // Always sort the resulting list
    return orderBy(officesToFilter, [(office) => office.name.toLowerCase()], ['asc']);
  }, [allOffices, debouncedFilterInput]);

   const clearFilters = () => {
    setFilterInput("");
  };

  return (
    <div>
      <Row className="mb-3 g-3 align-items-center p-3 bg-light rounded shadow-sm">
         <Col xs={12} md={9}>
          <Form.Group controlId="officeTextFilter">
            <Form.Label className="text-dark fw-semibold small mb-1">Search Offices</Form.Label>
            <Form.Control
              type="text"
              placeholder="Search name, description, ID..."
              value={filterInput}
              onChange={(e) => setFilterInput(e.target.value)}
              className="form-control-sm bg-white text-dark"
            />
          </Form.Group>
        </Col>

        {/*<Col xs={12} md={3} className="text-md-end align-self-end d-flex justify-content-end gap-2">*/}
        {/*   <Button variant="outline-secondary" size="sm" onClick={clearFilters} title="Clear filter" disabled={!filterInput}>*/}
        {/*       Clear*/}
        {/*   </Button>*/}
        {/*   <AddEntityButton onClick={() => setShowAdd(true)} text={strings.addNewOffice} />*/}
        {/*</Col>*/}
      </Row>

      <OfficeCrudModals
        showAdd={showAdd}
        officeId={selectedOfficeId}
        showDelete={showDelete}
        showEdit={showEdit}
        onAddClose={() => setShowAdd(false)}
        onEditClose={() => { setShowEdit(false); setSelectedOfficeId(undefined); }}
        onDeleteClose={() => { setShowDelete(false); setSelectedOfficeId(undefined); }}
      />

      <Row xs={1} sm={2} lg={3} xl={4} className="mt-1">
        {filteredOffices.length > 0 ? (
          filteredOffices.map((office) => (
            <OfficeItem
              key={office.id}
              office={office}
              onClickEdit={() => {
                setSelectedOfficeId(office.id);
                setShowEdit(true);
              }}
              onClickDelete={() => {
                setSelectedOfficeId(office.id);
                setShowDelete(true);
              }}
              onClickFolders={() => {
                history.push(`/offices/${office.id}`);
              }}
            />
          ))
        ) : (
           <Col>
             <p className="text-white-50 mt-3">
              No offices found matching your criteria.
              {(debouncedFilterInput) && (
                   <Button variant="link" size="sm" className="p-0 ms-2 text-warning" onClick={clearFilters}>Clear Filter</Button>
              )}
            </p>
          </Col>
        )}
      </Row>

      {selectedOfficeId && (
        <OfficeForeignIdMapModal
          officeId={selectedOfficeId}
          open={showForeignIdModal}
          onClose={() => { setShowForeignIdModal(false); setSelectedOfficeId(undefined); }}
        />
      )}
    </div>
  );
};
